// extracted by mini-css-extract-plugin
module.exports =  {"link-button":"_33974c2b58--link-button--ujZuh"};